import styled, { css } from 'styled-components'

export const CardHeader = styled.div<{ $centered: boolean }>`
  ${({ $centered }) => css`
    position: relative;
    display: flex;
    align-items: center;
    justify-content: ${$centered ? 'center' : 'flex-start'};
    width: 100%;
    padding: 1.5rem 3rem;
  `}
`

export const PositionIndicator = styled.span`
  ${({ theme }) => css`
    position: absolute;
    left: 1.5rem;
    font-family: ${theme.font.family};
    font-weight: ${theme.font.normal};
    font-size: ${theme.font.sizes.xsmall};
    color: ${theme.colors.neutral.low.medium};
  `}
`

export const CardTitle = styled.h2`
  ${({ theme }) => css`
    margin: 0;
    font-family: ${theme.font.family};
    font-weight: ${theme.font.normal};
    font-size: ${theme.font.sizes.medium};
  `}
`

export const CloseButton = styled.button`
  ${({ theme }) => css`
    position: absolute;
    right: 1.5rem;
    top: 50%;
    transform: translateY(-50%);
    display: flex;
    align-items: center;
    justify-content: center;
    background: transparent;
    border: none;
    cursor: pointer;
    color: ${theme.colors.dark};

    svg {
      font-size: ${theme.font.sizes.medium};
    }
  `}
`
